import makeStyles from '@mui/styles/makeStyles';

const useReortTableStyles = makeStyles({
  root: {},
  tableRightBorder: {
    borderWidth: 0,
    borderRightWidth: 1,
    borderColor: 'black',
    borderStyle: 'solid',
  },
});

export default useReortTableStyles;
